import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DocumentEffects } from 'stores/document/document.effects';
import * as fromDocument from './document.reducer';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromDocument.documentFeatureKey, fromDocument.reducers, {
            metaReducers: fromDocument.metaReducers,
        }),
        EffectsModule.forFeature([DocumentEffects]),
    ],
})
export class DocumentModule {}

export * as DocumentActions from './document.actions';
export * as DocumentSelectors from './document.selectors';
